/**
 * Generate a unique ID using timestamp and random component
 */
export function generateId(): string {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`
}
